<section class="d-flex align-items-center">
    <div class="container form-inicio">
    </div>
</section>